


















































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteMotivoTransferenciaSalaStore from '@/components/Suporte/Store/SuporteMotivoTransferenciaReservaStore'
import { MotivoTransferenciaReserva } from '@/types/_'
import { useHospitais } from '@/composables'

@Component

export default class ViewSuporteeMotivoTransferenciaSala extends Vue {
  $refs!: {
    form: any,
  }

  loadEditTable: string = ''
  loadTable: boolean = false
  loadSave: boolean = false
  loadLeave: boolean = false
  modal: boolean = false

  get pagination() {
    return this.getSuporteMotivoTransferenciaSalaStore.pagination
  }

  get getSuporteMotivoTransferenciaSalaStore() {
    return getModule(SuporteMotivoTransferenciaSalaStore, this.$store)
  }

  get loadingTable() {
    return this.loadTable
  }

  set loadingTable(value: boolean) {
    this.loadTable = value
  }

  get loadingEditTable() {
    return this.loadEditTable
  }

  set loadingEditTable(value: string) {
    this.loadEditTable = value
  }

  get loadingSave() {
    return this.loadSave
  }

  set loadingSave(value: boolean) {
    this.loadSave = value
  }

  get loadingLeave() {
    return this.loadLeave
  }

  set loadingLeave(value: boolean) {
    this.loadLeave = value
  }

  get getHospitalId() {
    return this.getSuporteMotivoTransferenciaSalaStore.hospitalId
  }

  set getHospitalId(value: any) {
    this.getSuporteMotivoTransferenciaSalaStore.setHospitalId(value)
  }

  get getHospitais() {
    return useHospitais.hospitaisByCurrentUser
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get headers() {
    return [
      { text: 'Descricao', value: 'descricao', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get getMotivosTransferenciaReserva() {
    return this.getSuporteMotivoTransferenciaSalaStore.motivosTransferenciaReserva
  }

  get getMotivoTransferenciaReserva() {
    return this.getSuporteMotivoTransferenciaSalaStore.motivoTransferenciaReserva
  }

  get getAcao() {
    return this.getSuporteMotivoTransferenciaSalaStore.acao
  }

  set getAcao(acao: string) {
    this.getSuporteMotivoTransferenciaSalaStore.setAcao(acao)
  }

  get conviteSearch() {
    return this.getSuporteMotivoTransferenciaSalaStore.conviteSearch
  }

  set conviteSearch(value: string) {
    this.getSuporteMotivoTransferenciaSalaStore.setConviteSearch(value)
  }

  async hospitalChange() {
    this.loadingTable = true
    await this.getSuporteMotivoTransferenciaSalaStore.getMotivosTransferenciaReservaByHospital()
    this.loadingTable = false
  }

  add() {
    this.getSuporteMotivoTransferenciaSalaStore.setAcao('Cadastrar')
    this.modal = true
  }

  async edit(item: MotivoTransferenciaReserva) {
    this.loadingEditTable = item.id
    this.getSuporteMotivoTransferenciaSalaStore.setAcao('Editar')
    this.modal = true
    this.getSuporteMotivoTransferenciaSalaStore.setMotivoTransferenciaReserva({ ...item })
    this.loadingEditTable = ''
    this.$refs.form.resetValidation()
  }

  async send() {
    this.loadingSave = true
    if (this.$refs.form.validate()) {
      const response = await this.getSuporteMotivoTransferenciaSalaStore.send()
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Dados enviado com sucesso!', icon: 'done', color: '#2E7D32', timeout: 4000 })
        this.closeModalIntegrador()
        await this.hospitalChange()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um erro ao enviar dados no servidor.', icon: 'warning', color: '#C62828', timeout: 4000 })
      }
    }
    this.loadingSave = false
  }

  leave() {
    this.loadingLeave = true
    this.closeModalIntegrador()
    this.loadingLeave = false
  }

  closeModalIntegrador() {
    this.modal = false
    this.getSuporteMotivoTransferenciaSalaStore.clearMotivoTransferenciaReserva()
    this.$refs.form.reset()
  }

  beforeDestroy() {
    this.closeModalIntegrador()
    this.getSuporteMotivoTransferenciaSalaStore.setHospitalId('')
    this.getSuporteMotivoTransferenciaSalaStore.setConviteSearch('')
    this.getSuporteMotivoTransferenciaSalaStore.setMotivosTransferenciaReserva([])
  }
}
